var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVehicle5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "64.000000pt",
    height: "64.000000pt",
    viewBox: "0 0 64.000000 64.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,64.000000) scale(0.100000,-0.100000)",
    fill: "current",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M440 330 c0 -30 0 -30 -59 -30 -43 0 -60 -4 -65 -15 -8 -22 -171 -22 -180 0 -4 11 -22 15 -71 15 -69 0 -84 -13 -45 -38 17 -10 21 -10 26 3 4 8 12 15 20 15 17 0 18 -17 2 -23 -7 -3 5 -3 27 -2 88 7 233 7 244 1 6 -4 14 0 17 8 3 9 12 16 20 16 17 0 18 -17 2 -23 -7 -2 1 -4 19 -3 17 1 35 4 38 8 4 4 29 4 56 1 29 -3 49 -2 49 4 0 14 44 10 53 -5 7 -11 12 -10 27 5 28 29 9 53 -45 53 -25 0 -45 5 -45 10 0 6 6 10 13 11 6 1 1 4 -13 8 -14 5 -29 4 -34 -1 -6 -4 -19 -8 -30 -7 -18 1 -17 2 4 9 l25 8 -27 1 c-25 1 -28 -3 -28 -29z m-320 -60 c0 -5 -4 -10 -10 -10 -5 0 -10 5 -10 10 0 6 5 10 10 10 6 0 10 -4 10 -10z m310 0 c0 -5 -4 -10 -10 -10 -5 0 -10 5 -10 10 0 6 5 10 10 10 6 0 10 -4 10 -10z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicle5);
export default __webpack_public_path__ + "static/media/vehicle5.51ba497327b9722c7ab47d7f7085204f.svg";
export { ForwardRef as ReactComponent };